export const BRAND = {
  name: "EvtTuning",
  phone: "+44 7391 705575",
  phoneHref: "tel:+447391705575",
  whatsapp: "https://wa.me/447391705575",
  email: "info@evttuning.uk",
  area: "North West London",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/10292236/pexels-photo-10292236.jpeg?auto=compress&cs=tinysrgb&w=1920",
  tech: "https://images.pexels.com/photos/8478235/pexels-photo-8478235.jpeg?auto=compress&cs=tinysrgb&w=1260",
  engine: "https://images.pexels.com/photos/9661360/pexels-photo-9661360.jpeg?auto=compress&cs=tinysrgb&w=1260",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why EvtTuning", href: "#why" },
  { label: "Our Process", href: "#process" },
  { label: "Results", href: "#results" },
  { label: "Pricing", href: "#pricing" },
];

export const STATS = [
  { value: 30, suffix: "%", label: "More power potential" },
  { value: 15, suffix: "%", label: "Better fuel economy" },
  { value: 1500, suffix: "+", label: "Vehicles tuned" },
  { value: 10, suffix: "+", label: "Years experience" },
];

export const SERVICES = [
  { icon: "Gauge", title: "ECU Remapping", desc: "Stage 1, Stage 2 and bespoke software, calibrated around your car and what you want from it.", points: ["Extra power & torque", "Crisper throttle feel", "Calibration built for you"] },
  { icon: "Fuel", title: "Better Fuel Economy", desc: "An efficiency-focused map that helps you stretch every tank a little further.", points: ["Improved MPG potential", "Relaxed everyday driving", "Great for commuters & fleets"] },
  { icon: "Wrench", title: "Diagnostics & Fault Finding", desc: "Professional-grade diagnostic equipment to find problems fast and fix them properly.", points: ["Fault code reading", "Live sensor data", "Straightforward advice"] },
  { icon: "Filter", title: "DPF / EGR / AdBlue", desc: "Practical solutions for the diesel system issues that keep drivers off the road.", points: ["DPF fault support", "EGR diagnosis", "AdBlue solutions"] },
  { icon: "Settings2", title: "Custom Tuning", desc: "One-off calibrations for modified cars, matched to the parts you have fitted.", points: ["Hardware-matched maps", "Performance setup", "Proven on the road"] },
  { icon: "Car", title: "All Makes & Models", desc: "From hatchbacks to vans, we support a wide range of vehicles across London.", points: ["Cars", "SUVs & vans", "4x4 vehicles"] },
];

export const WHY = [
  { icon: "Award", title: "Performance Reimagined", desc: "Maps tailored to your vehicle, your upgrades and your driving style." },
  { icon: "ShieldCheck", title: "Safe & Reliable", desc: "A full health check comes first, so your engine stays protected." },
  { icon: "Truck", title: "Mobile & Workshop", desc: "We come to you across North West London, or you can visit us." },
  { icon: "MapPin", title: "Local Specialists", desc: "A friendly, local tuning team you can rely on year after year." },
];

export const STEPS = [
  { n: "01", icon: "MessageSquare", title: "Tell Us About Your Vehicle", desc: "Send us the make, model, engine and the improvements you're after." },
  { n: "02", icon: "Activity", title: "Vehicle Health Check", desc: "We scan the car and recommend the most suitable option." },
  { n: "03", icon: "Cpu", title: "Tailored Remap", desc: "Your ECU receives a calibration designed for your car and goals." },
  { n: "04", icon: "Zap", title: "Enjoy the Difference", desc: "Feel stronger pull, quicker response and a smoother drive." },
];

export const RESULTS = [
  { car: "BMW 3 Series", spec: "Stage 3 · 330i M Sport", before: 258, after: 330, torqueBefore: 400, torqueAfter: 500, img: "/results/bmw-3-series.jpg" },
  { car: "BMW 8 Series Gran Coupé", spec: "Stage 3 · 840i M Sport", before: 360, after: 560, torqueBefore: 500, torqueAfter: 700, img: "/results/bmw-8-series.jpg" },
  { car: "Cupra Formentor VZ", spec: "Stage 1 · 2.0 TSI", before: 306, after: 365, torqueBefore: 400, torqueAfter: 480, img: "/results/cupra-formentor.jpg" },
  { car: "VW Golf GTI Mk5", spec: "Stage 1 · 2.0 TFSI", before: 197, after: 245, torqueBefore: 280, torqueAfter: 350, img: "/results/vw-golf-gti-mk5.jpg" },
  { car: "Porsche Macan", spec: "Stage 1 · 3.0 Turbo S", before: 354, after: 410, torqueBefore: 370, torqueAfter: 620, img: "/results/porsche-macan.jpg" },
  { car: "BMW X3 M Competition", spec: "Stage 2 · 3.0 Twin Turbo", before: 510, after: 700, torqueBefore: 600, torqueAfter: 850, img: "/results/bmw-x3-m.jpg" },
];

export const REVIEWS = [
  { name: "Daniel Harper", car: "BMW 3 Series 330i M Sport", text: "Stage 1 has made the 330i feel like a completely different car. Much stronger mid-range pull and smoother gear changes, yet it's still perfectly relaxed on the motorway." },
  { name: "James Whitfield", car: "BMW 8 Series 840i Gran Coupé", text: "I was nervous about tuning the 840i, but they talked me through everything first. The extra power is effortless and the car drives exactly as refined as before. Brilliant workshop." },
  { name: "Sofia Martins", car: "Cupra Formentor VZ", text: "The Formentor was quick already, but now the throttle response is instant and it pulls hard all the way through the revs. Friendly service and a really clean workshop." },
  { name: "Liam Carter", car: "VW Golf GTI Mk5", text: "Brought my old GTI in for a health check and a Stage 1 map. They spotted a sensor fault before tuning and fixed it. It's never felt this lively. Honest people." },
  { name: "Raj Mehta", car: "Porsche Macan 2.0", text: "Very professional from start to finish. The Macan feels far more eager now, especially when overtaking, and fuel economy on my commute has actually improved." },
  { name: "Marcus Bell", car: "BMW X3 M Competition", text: "Stage 1 on the X3 M is seriously impressive. Huge torque, no warning lights and it's still smooth around town. They clearly know these engines inside out." },
];

export const PRICING = [
  { name: "Stage 1", price: 199, cta: "Book Stage 1", service: "Stage 1 Remap", details: {
    tagline: "Performance & Efficiency",
    intro: "Unlock your vehicle's potential with our Stage 1 ECU remapping service. We optimise your engine software to deliver improved power, increased torque and sharper throttle response — without the need for hardware upgrades on suitable vehicles.",
    benefits: ["Improved acceleration and responsiveness", "Enhanced driving performance", "Smooth, refined power delivery", "Potential fuel-efficiency improvements with sensible driving"],
    note: "Suitable for many standard vehicles, subject to vehicle condition and compatibility.",
  }, features: ["ECU software calibration", "Vehicle health checks", "Before / after figures", "Diagnostics scan"] },
  { name: "Stage 2", price: 299, cta: "Book Stage 2", service: "Stage 2 Remap", popular: true, details: {
    tagline: "Maximum Road Performance",
    intro: "Take your car further with Stage 2. Building on a Stage 1 calibration, we tune your ECU to work with supporting hardware upgrades for a bigger, stronger power increase.",
    benefits: ["Significant power and torque gains", "Calibration matched to your upgraded parts", "Stronger pull through the rev range", "Hardware suitability check before tuning"],
    note: "Requires suitable supporting modifications (such as intake, intercooler or exhaust upgrades). We'll confirm your vehicle's requirements before booking.",
  }, features: ["Stage 2 calibration", "Hardware suitability check", "Before / after figures", "Diagnostics scan"] },
  { name: "Custom Tune", price: 349, cta: "Enquire Now", service: "Custom Tuning", details: {
    tagline: "Built Around Your Car",
    intro: "For modified and specialist vehicles, our Custom Tune is developed specifically for your car, your hardware and how you drive, from road setups to higher-performance builds.",
    benefits: ["Calibration developed for your exact setup", "Ideal for heavily modified vehicles", "Tailored power delivery and drivability", "Full diagnostic assessment included"],
    note: "Price and results depend on the vehicle and modifications. We'll discuss your goals and setup before any work begins.",
  }, features: ["Vehicle-specific requirements", "Custom calibration approach", "Performance profile", "Diagnostic assessment"] },
];

export const EXTRA_SERVICES = [
  { name: "Diagnostics / fault finding", price: "£50", notes: "Subject to vehicle and diagnostic time", service: "Diagnostics & Fault Finding" },
  { name: "ECU/TCU specialist work", price: "POA", notes: "Vehicle dependent", service: "Not sure yet" },
  { name: "Mobile call-out", price: "POA", notes: "Depends on location", service: "Not sure yet" },
];

export const OPENING_HOURS = [
  { days: "Monday – Friday", hours: "18:00 – 23:00" },
  { days: "Saturday – Sunday", hours: "10:00 – 22:00" },
];

export const MOBILE_SERVICE_OPTIONS = ["Diagnostics & Fault Finding"];

// Workshop services that can be paid in full online (card, Klarna, PayPal)
export const ONLINE_PRICES = { "Stage 1 Remap": 199, "Stage 2 Remap": 299, "Custom Tuning": 349 };

export const SERVICE_OPTIONS = [
  "ECU Remapping",
  "Stage 1 Remap",
  "Stage 2 Remap",
  "Custom Tuning",
  "Better Fuel Economy",
  "DPF / EGR / AdBlue Solutions",
  "Diagnostics & Fault Finding",
  "Not sure yet",
];
